import { inject, injectable } from "inversify";
import {
  ICPLUserTasksClient,
  IntSelectModel,
  NewUserTaskModel,
  UserTaskFiltersModel,
  UserTaskModel,
} from "./api/cplapi/CPLAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { timeRemainingHelper } from "cpl-react-common/Helpers/TimeRemainingHelper";

type TimeRemaining = {
  timeRemainingString: string;
  taskOverdue: boolean;
  dueToday: boolean;
};

export interface IUserTasksService {
  getUserTask(userTaskID: number): Promise<UserTaskModel>;
  createUserTask(newUserTaskModel: NewUserTaskModel): Promise<number>;
  updateUserTask(userTaskModel: UserTaskModel): Promise<void>;
  holdTask(userTaskID: number): Promise<void>;
  resumeTask(userTaskID: number): Promise<void>;
  cancelUserTask(userTaskID: number): Promise<void>;
  getUserTaskTypeSelectModels(): Promise<IntSelectModel[]>;
  getUserTaskStatusTypeSelectModels(): Promise<IntSelectModel[]>;
  getUsersTasks(userTaskFilters: UserTaskFiltersModel): Promise<UserTaskModel[]>;
  getTimeRemaining(userTaskModel: UserTaskModel): TimeRemaining;
}

@injectable()
export class UserTasksService implements IUserTasksService {
  @inject(SERVICE_TYPES.CPLUserTasksClient) cplUserTasksClient!: ICPLUserTasksClient;

  async getUserTask(userTaskID: number): Promise<UserTaskModel> {
    return this.cplUserTasksClient.getUserTask(userTaskID);
  }

  async createUserTask(newUserTaskModel: NewUserTaskModel): Promise<number> {
    return this.cplUserTasksClient.createUserTask(newUserTaskModel);
  }

  async updateUserTask(userTaskModel: UserTaskModel): Promise<void> {
    return this.cplUserTasksClient.updateUserTask(userTaskModel);
  }

  async holdTask(userTaskID: number): Promise<void> {
    return this.cplUserTasksClient.holdTask(userTaskID);
  }

  async resumeTask(userTaskID: number): Promise<void> {
    return this.cplUserTasksClient.resumeTask(userTaskID);
  }

  async cancelUserTask(userTaskID: number): Promise<void> {
    return this.cplUserTasksClient.cancelUserTask(userTaskID);
  }

  async getUserTaskTypeSelectModels(): Promise<IntSelectModel[]> {
    return this.cplUserTasksClient.getUserTaskTypeSelectModels();
  }

  async getUserTaskStatusTypeSelectModels(): Promise<IntSelectModel[]> {
    return this.cplUserTasksClient.getUserTaskStatusTypeSelectModels();
  }

  async getUsersTasks(userTaskFilters: UserTaskFiltersModel): Promise<UserTaskModel[]> {
    return this.cplUserTasksClient.getUserTasks(userTaskFilters);
  }

  getTimeRemaining(userTaskModel: UserTaskModel): TimeRemaining {
    return timeRemainingHelper(undefined, userTaskModel.closedDate, userTaskModel.slaTargetDate);
  }
}
